import { Phone, MessageCircle, Send } from "lucide-react";
import { COMPANY, WHATSAPP_URL, scrollToId } from "../constants";

export const MobileBar = () => (
  <div
    className="fixed bottom-0 inset-x-0 z-50 md:hidden bg-white border-t border-gray-200 shadow-[0_-6px_20px_-8px_rgba(11,25,44,0.25)]"
    data-testid="mobile-conversion-bar"
  >
    <div className="grid grid-cols-3 divide-x divide-gray-200 pb-[env(safe-area-inset-bottom)]">
      <a
        href={COMPANY.phoneHref}
        className="flex flex-col items-center justify-center gap-1 py-3 text-navy"
        data-testid="mobilebar-call"
      >
        <Phone className="w-5 h-5" />
        <span className="text-xs font-semibold">Anrufen</span>
      </a>
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="flex flex-col items-center justify-center gap-1 py-3 text-conv"
        data-testid="mobilebar-whatsapp"
      >
        <MessageCircle className="w-5 h-5" />
        <span className="text-xs font-semibold">WhatsApp</span>
      </a>
      <button
        onClick={() => scrollToId("kontakt")}
        className="flex flex-col items-center justify-center gap-1 py-3 text-brand"
        data-testid="mobilebar-angebot"
      >
        <Send className="w-5 h-5" />
        <span className="text-xs font-semibold">Angebot</span>
      </button>
    </div>
  </div>
);
